// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { OrderLineDetail } from './order-line-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class WarrantyRegistration extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get customerName(): string {
    return `${this.firstName??''} ${this.lastName??''}`.trim();
  }

  get address(): string {
   let address = [];
    if (this.address1) address.push(this.address1.toUpperCase());
    if (this.address2) address.push(this.address2.toUpperCase());
    if (this.cityStateZip) address.push(this.cityStateZip.toUpperCase());
    return address.join('<br>');

  }

  get cityStateZip(): string {
    let cityStateZip = [];
    if (this.city) cityStateZip.push(this.city);
    if (this.state) cityStateZip.push(this.state);
    if (this.zip) cityStateZip.push(this.zip);
    return cityStateZip.join(', ');
  }

  get isAcknowledged(): boolean {
    return !!this.acknowledged;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  acknowledged?: Date;
  acknowledgedBy?: string;
  address1?: string;
  address2?: string;
  city?: string;
  country?: string;
  created!: Date;
  dealerName?: string;
  deleted?: Date;
  deletedBy?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  orderLineDetailId?: number;
  phone?: string;
  phone2?: string;
  processed?: Date;
  purchased!: Date;
  rawData?: string;
  state?: string;
  trailerModel?: string;
  vIN?: string;
  zip?: string;
  orderLineDetail!: OrderLineDetail;
}

